module.exports = __webpack_public_path__ + "img/logoad.1f8f3f19.png";